import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import DeleteConfirmation from './DeleteConfirmation';

function Modal() {
    const [visible, setVisible] = useState(false);

    const activeModal = useSelector((state) => state.inventoryManagement.modal.activeModal);
    const displayModal = useSelector((state) => state.inventoryManagement.modal.displayModal);

    useEffect(() => {
        if(displayModal) {
            setVisible(true);
        } else {
            setVisible(false);
        }
    }, [displayModal]);

    return (
        <div className={`${visible ? 'opacity-100 visible bg-[#00000080]' : 'opacity-0 invisible'} transition-all duration-100 ease-in-out fixed z-50 size-full top-0 left-0 flex justify-center items-center`}>
            {activeModal === 'delete-confirm' && <DeleteConfirmation />}
        </div>
    );
}

export default Modal;
